import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { AuthContext } from '../../../Context/AuthContext';
import { Spin, Modal, Result } from 'antd';
import LoginForm from './LoginForm';
import { useIntl, FormattedMessage } from 'react-intl';
import OtpForm from './OtpForm';
import CodeForm from './CodeForm';
import useAuth from '../../../Hook/useAuth';
// import { compose, withApollo  } from 'react-apollo';
import { compose } from "recompose"
import { withApollo } from "@apollo/client/react/hoc"
import withUser from '../../hocs/withUser';
import config from '../../../config';
import { Capacitor } from '@capacitor/core'
import platformObj from '~/config'



const LoginPage = ({ history,client, location, currentUser, updateUser }) => {
  const intl = useIntl();
  const { signInPhoneNumber , 
          confirmationOtp, 
          getUserByEmail, 
          logInWithEmailPassword, 
          sendSignInLink ,
          signInPhoneNumberNative,
          confirmationOtpNative , 
          facebookLogIn ,
          requestToResetPassword,
          requestLoginCode,
          verifyLoginCode
        } = useAuth();
  const { user, userIsLoading } = useContext(AuthContext);
  const [requestOpt, setRequestOtp] = useState(false);
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [acceptPolicy, setAcceptPolicy] = useState(false)
  const [result , setResult] = useState(null)
  const [methods , setMethods] = useState([])
  // const [showEmailForm , setShowEmailForm] = useState(false)
  const isNative = Capacitor.isNativePlatform()
  const [loading, setLoading] = useState(false)
  const [initialPhoneNumber , setInitialPhoneNumber] = useState(null)
  const [initialCode , setInitialCode] = useState(config.defaultPhoneCode)
  const [ requestCode , setRequestCode ] = useState(false)
  const [ userEmail , setUserEmail ] = useState(null)
  
  useEffect(() => {
    
    if (user && userIsLoading) {
      // return history.push('/');
      setRequestOtp(false)
      setResult(null)
      // setShowEmailForm(true)
    }
    // if(currentUser && !currentUser.email) {
    //   setShowEmailForm(true)
    // }
    if(currentUser && currentUser.email){
      history.push(location.state?.from.pathname ||"/");
    }
    if (!user && userIsLoading) {
      return () => {
        return (
          <div className="modLoadding">
            <Spin tip="Loading..." size="large" />
          </div>
        );
      };
    }

    return ;
  }, []); // eslint-disable-line

 
  const onRequestOtp = async (phoneNumber) => {
    try {
      setLoading(true)
      let result 
      if(isNative) {
        result = await signInPhoneNumberNative(phoneNumber)
        // result = res.verificationId
      }
      else{
        result = await signInPhoneNumber(phoneNumber);
      }
      
      setRequestOtp(true);
      if(!result.success){
        setAcceptPolicy(false)
        setRequestOtp(false);
        setConfirmationResult(null);
        setLoading(false)
        return handleError(result.error);
      }
      
      setConfirmationResult(result);
      setLoading(false)

    } catch (error) {
      console.error(error);
      return handleError(error);
    }
  };


  const handleSubmitOtp = async (otp) => {
    try {
      setLoading(true)
      
      if(isNative){
        const res = await confirmationOtpNative(confirmationResult.result , otp , confirmationResult.mode)
        if (!res.success) {
          setLoading(false)
          return handleError(res.error);
        }
        if (res.success){
          history.push("/");
          setLoading(false)
          return
        }
      }
      else {
        const res = await confirmationOtp(confirmationResult.result, otp, confirmationResult.mode);
        if (!res.success) {
          setLoading(false)
          return handleError(res.error);
        }
        if (res.success){
          setLoading(false)
          history.push( location.state?.from.pathname || "/")
          window.location.reload()
          // return
        }
        
      }  
      
      
    } catch (error) {
      return handleError(error);
    }
  };

  function handleError(error) {
    Modal.error({
      title: intl.formatMessage({ id: 'app.auth.loginFail' }),
      content: error
    });
  }

  const handleAcceptPolicy = (e) => {
    setAcceptPolicy(e.target.checked)
  }

  const handleGetUserByEmail= async(email)=>{
    setLoading(true)
    
    const res = await getUserByEmail({email , navigatePath: location.state?.from.pathname})
    
    if(res.success && res.methods !==undefined){
      setMethods(res.methods)
      setLoading(false)
      return
    }
    if(res.success){
      setResult(true)
      setLoading(false)
      return
    }
    if(!res.success){
      setResult(false)
      setLoading(false)
      return
    }    
  }

  const handleSignInWithPassword =async(email, password) =>{
    setLoading(true)

    const res = await logInWithEmailPassword({email:email, password:password})
    if (res.error) {
      handleError(res.error);
      setLoading(false)
      return;
    }

    setLoading(false)
    if(isNative){
      history.push("/")
      return
    }
    
    history.push(location.state?.from.pathname ||"/")
   
  }
  const handleSignInWithLink =async(email)=>{
    setLoading(true)

    const url= `${process.env.REACT_APP_BASE_URI}/signin/`
    const res = await sendSignInLink({email,url , navigatePath:location.state?.from.pathname ||"/"} )
    if(res.success){
      setResult(true)
      setLoading(false)
      // setTimeout(()=>{history.push("/")},2000)
      return
    }
    if(!res.success){
      setResult(false)
      setLoading(false)
      // setTimeout(()=>{history.push("/login")},2000)
      return
    }  
  }

  const handleResetPassword = async (email)=>{
    /////THIS IS THE CASE THAT USER IS NOT LOGGED IN YET 
    // CHECK THE EXISTING OF USER BY EMAIL 
    //////IF EXIST SEND EMAIL VERIFY 
    //////IF NOT SEND 404 => HANDLE ERROR 
    
    const res = await requestToResetPassword({email, navigatePath:location.state?.from.pathname ||"/" })
    if(res.success){
      setResult(true)
      return
    }
    if(!res.success){
      setResult(false)
      return
    }  
  }
  // const handleSubmitEmail = async(email)=>{
  //   try{

  //      /////update email in api
  //      const success = await requestEmailMutation({variables:{email, userId : currentUser._id}})

  //       if(success){
  //       ///update email in firebase 
  //         await updateUserEmail(email)

  //         client
  //         .query({
  //           query: fetchUser,
  //           fetchPolicy: 'network-only'
  //         })
  //         .then(async() => {
  //           await client.reFetchObservableQueries();
  //           history.push(location.state?.from.pathname ||"/")
  //         })
  //       }
        
  //   }catch(error){
  //     console.error({error});
  //     let errorMessage = error
  //     if(error.message.includes("E11000")) errorMessage = "This email is existed please submit another email"
  //     handleError(errorMessage)
  //   }
  // }

  const handleFacebookLogin =async()=>{
    const res = await facebookLogIn();
    if (res.error) {
      handleError(res.error);
      return;
    }
    history.push(location.state?.from.pathname ||"/")
  }

  const handleBackToLoginForm =()=>{
    setRequestOtp(false)
    setRequestCode(false)
  }

  const handleRequestLoginCode= async(email) =>{
    setUserEmail(email)
    const res = await requestLoginCode(email)
    
    if(res.success){
      setRequestCode(true)
    }
    if(res.error){
      handleError(res.error)
      setRequestCode(false)      
    }
  }

  const handleSubmitCode = async(code)=>{
    const res = await verifyLoginCode(code, userEmail)
    // console.log(res);
    if(!res.success){
      handleError(res.error)
      setRequestCode(false)
    }
    isNative && history.push("/")
    
  }

  return (
    <div style={{position:"relative",background:"#EAEBEF", overflow:"hidden", width:"100%" , height:"100vh" , display:"flex" , justifyContent:"center" , alignItems:'center'}}>
      <div style={{background:"linear-gradient(rgb(255,162,2,1),rgb(255,84,201,1))", width :"100%" , height :"36%" , position:"absolute" , top:0 , left:0 ,zIndex:"0" , borderRadius:"0 0 32px 32px" }}/> 
      <div
        style={{
          width: 320,
          paddingLeft:8,
          paddingRight:8,
          // height:"100%",
          overflow:"hidden",
          animationDuration: `${1.2}s`,
          animationDelay: `${0}s`,
          display: 'flex',
          justifyContent:"center",
          flexDirection: 'column',
          alignItems: 'center',
          // marginTop: isNative ? "50%":"16%",
          background:"white",
          borderRadius:"10px",
          border:"1px solid #eee",
          boxShadow :"3px 3px 5px #999",
          zIndex:1
        }}
        >
          
        <div className="loginModalHeader" style={{ width: '100%' }}>
        {process.env.REACT_APP_PLATFORM !== 'maybank' &&
          <div style={{display:"flex" , alignItems:'center' , justifyContent:"space-around"}}>
            <img
              src="logorunner.png"
              style={{ width: '100%', maxWidth: '90px', marginBottom: 20 }}
              alt="logo"
            />
            <div style={{display:"flex"  ,flexDirection:"column", alignItems:"start" }}>
              <h1 style={{ fontWeight: '500' , fontSize:24, lineHeight:2 }} >
                <FormattedMessage id="app.welcomeTo"/>
              </h1>
              <h1 style={{ fontWeight: 'bold' , fontSize:48 ,lineHeight:0 }}>{config.brandName}</h1>
            </div>
          </div>
          }
          {process.env.REACT_APP_PLATFORM === 'maybank' &&
            <img
            src={platformObj.logo.urlLogin}
            style={{ width: '100%', maxWidth: '300px', marginBottom: 20,  }}
            alt="logo"
          />
          }

          {!requestOpt && result===null && !requestCode && (<>
          {/* {!requestOpt && result===null && !showEmailForm && (<> */}

            <LoginForm 
              loading = { loading }
              onRequestOtp={onRequestOtp}
              handleError={handleError}
              acceptPolicy={acceptPolicy}
              handleAcceptPolicy={handleAcceptPolicy}
              handleGetUserByEmail={handleGetUserByEmail}
              methods={methods}
              handleSignInWithLink={handleSignInWithLink}
              handleSignInWithPassword={handleSignInWithPassword}
              handleFacebookLogin={handleFacebookLogin}
              handleResetPassword={handleResetPassword}
              initialPhoneNumber={initialPhoneNumber}
              setInitialPhoneNumber = {setInitialPhoneNumber}
              initialCode={ initialCode }
              setInitialCode = { setInitialCode }
              handleRequestLoginCode= {handleRequestLoginCode}
            />
          </>
          )}
          {requestOpt && <OtpForm number={initialPhoneNumber} loading={ loading } handleBackToLoginForm={handleBackToLoginForm} handleSubmitOtp={handleSubmitOtp} />}
          {requestCode && <CodeForm handleBackToLoginForm={handleBackToLoginForm} email={userEmail} handleSubmitCode={handleSubmitCode} loading={loading}/>}
          {/* {showEmailForm && !requestOpt && !result && <EmailForm handleSubmitEmail={handleSubmitEmail} />} */}
          {result && <Result
            status="success"
            title={intl.formatMessage({id:"app.auth.emailSent"})}
            subTitle={intl.formatMessage({id:"app.auth.emailSentDescription"})}
          />}
          {result===false && <Result
              status="error"
              title={intl.formatMessage({id:"app.auth.someThingWentWrong"})}
              subTitle={intl.formatMessage({id:"app.auth.pleaseTryAgain"})}
            />
            }
        </div>
        {/* { process.env.REACT_APP_PLATFORM === 'maybank' &&
          <div className="links" style={{display:"flex" ,flexDirection:"column", justifyItems:"start", position: 'fixed',width: '100', bottom: '0'}}>
            <h1 style={{ fontWeight: '400' , fontSize:12, lineHeight:2}}>
              <a className="outsideLink" style={{ color : 'black'}} href='https://www.thai.run/'>powered by ThaiRun</a>
            </h1>
          </div>
        } */}
        
      </div>
      
    </div>
  );
};

export default compose(
  withApollo, 
  withRouter , 
  withUser({ refetch: false }),
)(LoginPage);
